import React, { ReactElement } from "react";

export default function MagnifyingClass(props: React.SVGProps<any>): ReactElement {
  return (
    <svg viewBox="0 0 1000 1000" width="1em" height="1em" {...props}>
      <path d="M932.8 850l-201-201c56.4-67.6 90.3-154.5 90.3-249.5C822.2 184.2 647.9 10 432.7 10 217.4 10 43.2 184.2 43.2 399.5 43.2 614.7 217.4 789 432.7 789c61.1 0 119-14.1 170.5-39.1 3 4.7 6.6 9.1 10.7 13.2l203 203c32 32 84 32 116 0 31.9-32.1 31.9-84.1-.1-116.1zM125.2 399.5C125.2 229.7 262.9 92 432.7 92s307.5 137.7 307.5 307.5S602.4 707 432.7 707c-169.8 0-307.5-137.7-307.5-307.5z" />
    </svg>
  );
}
